import { Injectable } from '@angular/core';
import { SharedHttpService } from './shared-http.service';
import * as moment from 'moment';
@Injectable({
    providedIn: 'root'
})

export class InternalReportService {

    reportData: any;
    constructor(private sharedService: SharedHttpService) { }

    convertNumerals(input: string) {
        if (input == null)
            return "";
        else
            return input.toString().split('0').join('٠')
                .split('1').join('١')
                .split('2').join('٢')
                .split('3').join('٣')
                .split('4').join('٤')
                .split('5').join('٥')
                .split('6').join('٦')
                .split('7').join('٧')
                .split('8').join('٨')
                .split('9').join('٩');
    }
    transformToDateOnly(value: string): string {
        if (value != null && value.trim() != "") {
            let ret = "";
            ret = moment(value).format('DD-MM-YYYY');

            return ret;
        }
        return "";
    }
    printReport(caseId) {

        this.sharedService.get(`api/Case/GetInternalReport?CaseId=${caseId}`).subscribe(result => {
            this.reportData = result;
            let crRelatedPersons = '';
            let legalArticles = '';
            let evidences = '';
            let callRecords = '';
            let reports = '';
            let members = '';
            let offender = '';
            let qualityNotes = '';
            let reportNotes = '';
            let actionTaken = '';
            let subject = '';
            let branchManagerName = '';
            let qualityName = '';
            let daysNumber = '';
            let returnNumber = '';
            let fullName = this.sharedService.CurrentUser.fullName;
            let currentDateTime = moment((new Date)).format('DD/MM/YYYY - h:mm');
            let companyName = '';


            if (this.reportData.company) {
                if(this.reportData.company.crRelatedPrsons.length!=0){
                    this.reportData.company.crRelatedPrsons.map((person, index) => {
                        crRelatedPersons = crRelatedPersons.concat(`
                            <tr>
                                <td style="  border: 1px solid black; -collapse: collapse;">${person.name? person.name : ''}</td>
                                <td style="  border: 1px solid black; border-collapse: collapse;">${person.identityNumber ? this.convertNumerals(person.identityNumber) : ''}</td>
                                <td style="  border: 1px solid black; border-collapse: collapse;">${person.relationName ? person.relationName : ''}</td>
                                <td style="  border: 1px solid black; border-collapse: collapse;">${person.mobile ? this.convertNumerals(person.mobile) : '' }</td>
                                <td style="  border: 1px solid black; border-collapse: collapse;">${person.nationalityName ? person.nationalityName : ''}</td>
                            </tr>`
                        );
                    });
                }
            }
            if (this.reportData.company != null) {
                companyName = companyName.concat(`
                <p>اولاً: بيانات الشركة:</p>
                <p class="padding-right">إسم الشركة أو المؤسسة: ${this.reportData.company.name ? this.reportData.company.name : ''}</p>
                <p class="padding-right">رقم السجل التجاري: ${this.reportData.company.crnumber ? this.convertNumerals(this.reportData.company.crnumber) : ''}</p>
                <p class="padding-right">رقم الشركة/المؤسسة الوطني: ${ this.reportData.company.nationalNumber ? this.convertNumerals(this.reportData.company.nationalNumber) : ''}</p>
                <p class="padding-right">العنوان: ${this.reportData.company.address ? this.convertNumerals(this.reportData.company.address) : ''}</p>
                <p class="padding-right">النشاط: ${ this.reportData.company.activity ? this.convertNumerals(this.reportData.company.activity) : ''}</p>
                <table  style="width: 100%;  border: 1px solid black; border-collapse: collapse;text-align: center; margin: 20px 0px;">
                    <tr style="font-weight: bold;">
                        <th style=" border: 1px solid black;
                        border-collapse: collapse;">الإسم</th>
                        <th style=" border: 1px solid black;
                        border-collapse: collapse;">رقم الهوية/الإقامة</th>
                        <th style=" border: 1px solid black;
                        border-collapse: collapse; ">العلاقة بالشركة/المؤسسة</th>
                        <th style=" border: 1px solid black;
                        border-collapse: collapse; ">رقم الجوال</th>
                        <th style=" border: 1px solid black;
                        border-collapse: collapse; ">الجنسية</th>
                    </tr>
                    ${crRelatedPersons} 
                </table>`);

            }
            if (this.reportData.actionTaken) {
                actionTaken = actionTaken.concat(`<p>خامساً: الإجراءات المتخذة:</p>
                <p> بناءً على البلاغ الوارد للوزارة تم اتخاذ الإجراءات التالية  :  </p> <P>- ${this.convertNumerals(this.reportData.actionTaken)} </P> <hr/>` );
            }

            legalArticles = legalArticles + "<p>سابعاً: نتيجة الدراسة</p>";
             legalArticles = legalArticles.concat(` 
                <p>بدراسة البلاغ والأدلة المقدمة واتخاذ كافة الإجراءات النظامية تبين لنا الآتي:   </p>`);
                     
            if (this.reportData.legalArticles != '' && this.reportData.legalArticles !=null) {
             
                this.reportData.legalArticles.map((legalArticle,i) => {

                    legalArticles = legalArticles.concat(`  
                        <p class="padding-right" > - ${legalArticle.legalArticleTitle ?this.convertNumerals(legalArticle.legalArticleTitle) : ''}</p>
                    `);
                    
                    if(i=== this.reportData.legalArticles.length-1){
                        legalArticles= legalArticles.concat(`<hr/>`)
                    }
                });
            }
            if(this.reportData.studyResults){
                legalArticles = legalArticles.concat(` <p class="padding-right"> - ${this.reportData.studyResults}</p>`)
            }



            if (this.reportData.evidences != '') {
                evidences = evidences.concat(`<p>رابعاً: الادلة والقرائن: </p>`)

                if (this.reportData.evidencesText == null) {
                    evidences = evidences + '----';
                }
                else
                    evidences = evidences + `<P class="padding-right"> ${ this.reportData.evidencesText} </P> <hr/>` ;
            }
            if(this.reportData.callRecords.length!=0){
                this.reportData.callRecords.map((el,i) => {
                    callRecords = callRecords.concat(`
                        <p class="padding-right"> - اسم الشخص :${el.personName ? el.personName : ''} / سماع الاقوال :${ el.recordResults ?this.convertNumerals(el.recordResults) : ''} ${el.employeeNotes ? '/ ملاحظات الموظف : ' + el.employeeNotes : ''}</p> 
                    `);
                    if(i === this.reportData.callRecords.length -1){
                        callRecords = callRecords.concat(`<hr/>`)
                    }
                });
            }









            if (this.reportData.branchManagerName != null && this.reportData.branchManagerName!='') {
                branchManagerName = branchManagerName.concat(` <p>- اسم المدير  : ${this.reportData.branchManagerName ? this.reportData.branchManagerName : ''}  </p>  `);
            }
            if (this.reportData.qualityName != "" && this.reportData.qualityName !=null) {
                qualityName = qualityName.concat(` <p>- اسم موظف الجودة  : ${this.reportData.qualityName ?this.reportData.qualityName : ''} </p>  `);
            }
            if (this.reportData.returnNumber != 0) {
                returnNumber = returnNumber.concat(`
                <p>- عدد مرات الاعادة للموظف: -${this.reportData.returnNumber} </p> `);
            }
            if (this.reportData.daysNumber != 0) {
                daysNumber = daysNumber.concat(` <p>- المدة بالايام : -${this.reportData.daysNumber} </p>`);
            }


            let isOffenderExist=false;
            if(this.reportData.members.length !=0){

                this.reportData.members.map((el,i) => {
                    if (el.memberTypeId && el.memberTypeId == 5) {
                        members = members.concat(`
                        <p>ثانياً: </p>
                        <p class="padding-right"> ١. المدعي عليهم: </p>
                        <p class="padding-right"> - ${el.person.name? el.person.name : ''} هوية وطنية/الإقامة رقم ${ el.person.nationalIdOrIqama ? this.convertNumerals(el.person.nationalIdOrIqama) : ''}  بصفته ${el.memberTypeName ? el.memberTypeName : ''}</p>`);
                    }
                    if (el.memberTypeId && el.memberTypeId == 6) {
                        isOffenderExist=true;
                        offender = offender.concat(`
                        <p class="padding-right">٢. المدعي : </p>
                        <p class="padding-right"> -  ${ el.person.name ? el.person.name : ''} هوية وطنية/الإقامة رقم ${ el.person.nationalIdOrIqama ? this.convertNumerals(el.person.nationalIdOrIqama) : ''}  بصفته ${el.memberTypeName ? el.memberTypeName : ''}</p>`);
                    }
                    if(i=== this.reportData.members.length -1 ){
                        if(isOffenderExist){
                            offender= offender.concat('<hr/>')
                        }else{
                            members= members.concat('<hr/>')
                        }
                    }
    
                });
            }
            // if (this.reportData.reports != '' && this.reportData.reports != '') {

            //     this.reportData.reports.map((el) => {
            //         if (this.reportData.reports == null) {
            //             reports = reports.concat(`<p>ثالثاً: حصر مضمون الادعاءات: </p>
            //             <h5> - تضمن البلاغ التالي: .</h5>`);
            //         } else
            //             reports = reports.concat(`<p>ثالثاً: حصر مضمون الادعاءات: </p>
            //     <h5> - تضمن البلاغ التالي: ${el.reportDetails}</h5>`);




            //     });

            // }
            if (this.reportData.claimContents != '' && this.reportData.claimContents != null) {
               reports = reports.concat(`<p>ثالثاً: حصر مضمون الادعاءات: </p>
                <p class="padding-right"> - ${this.reportData.claimContents}</p><hr/>`);            }
            else
                reports = `<p>ثالثاً: حصر مضمون الادعاءات:  </p> <hr/>`;




            if (this.reportData.qualityNotes) {
                qualityNotes = qualityNotes.concat(`<p>رأي موظف الجودة:</p>
                <p class="padding-right">${this.convertNumerals(this.reportData.qualityNotes)}</p>` );
            }
            if (this.reportData.reportNotes) {
                reportNotes = reportNotes.concat(`
                <p>إيضاحات أخرى :</p>
                ${this.reportData.otherInfo ? `<p class="padding-right"> ${this.reportData.otherInfo}</p>` : ' '}

                <p class="padding-right">- رأي عضو الضبط الجنائي</p>
                ${this.reportData.lakeOfDataName ? `<p class="padding-right"> ${this.reportData.lakeOfDataName}</p>` : ' '}
                <p class="padding-right">${this.convertNumerals(this.reportData.reportNotes)}</p>`);
            }
            // <a style="width:270px;margin:auto;display:flex" class="logo" routerLink='/'>
            //     <img style="width:30%;margin:auto" class="img-fluid for-light" src="../../../../../assets/images/logo/logo-icon.png" alt="looginpage">
            // </a>
            const body = `<div style=" width: 100%;padding-bottom: 60px">
            <div style="display:inline-block;
            float:right; margin: 0 auto;  width:200px">
            <a  class="logo" routerLink='/'>
            <img style="width:50%;margin-left:auto" class="img-fluid for-light" src="../../../../../assets/images/mclogo.png" alt="looginpage">
            </a> 
            </div>
            <div  style=" display:inline-block;
            float:left;
            width:200px;>
            <a  class="logo" routerLink='/'>
            <img style="width:60%" class="img-fluid for-light" src="../../../../../assets/images/Vision2030.png" alt="looginpage">
            </a> 
            </div>
            </div>
             
            <div  style="display:flex;flex-direction:column;align-items: center; justify-content:center">
            <h2>تقرير داخلي</h2>
                <span>   تقرير عن قضية رقم ${ this.reportData.caseNumber ?this.convertNumerals(this.reportData.caseNumber) : ''} بتاريخ ${ this.reportData.caseDatetime ?this.convertNumerals(this.transformToDateOnly(this.reportData.caseDatetime)) : ''} </span>
            </div>
             
            ${companyName ? companyName : '<p>اولاً: بيانات الشركة:</p>'} 
      
            <p class="padding-right">الموضوع </p>
            <p class="padding-right"> ${this.reportData.subject ? this.reportData.subject : ''}</p>
            <hr/>
            ${members ? members : ( isOffenderExist ? '<p>ثانياً: </p><p>١. المدعي عليهم: </p>' :'<p>ثانياً: </p><p>١. المدعي عليهم: </p> <hr/>')}
            ${offender ? offender : '<p>٢. المدعي : </p> <hr/>'}

            ${reports ? reports : ''} 


            ${evidences ? evidences : '<p>رابعاً: الادلة والقرائن: </p> <hr/>'}
            ${actionTaken ? actionTaken : ' <p>خامساً: الإجراءات المتخذة:</p><hr/> '}

            ${callRecords ? `<p>سادساً: سماع الأقوال</p>` + callRecords  : '<p>سادساً: سماع الأقوال :</p> <hr/>'}
   
            ${legalArticles ? legalArticles : ' <p>سابعاً: نتيجة الدراسة:</p> <hr/>'}
 
            
            <p> ${reportNotes ? reportNotes : '<p>إيضاحات أخرى :</p>'}</p ><hr/>
         
       
            <p> ${qualityNotes ? qualityNotes : ' <p>رأي موظف الجودة:</p>'}</p>

            <span style=" font-size: 20px;float:left"> طبع بواسطة : ${fullName}  ${currentDateTime} </span>`;
            // @media print {@page{ margin: .75in .5in;  }}
            let contents = `
                <html>
                    <head>
                        <style  type="text/css">
                        
        
                            @media print {
                            @page { margin: 0; }
                            body { margin: 1.0cm; }
                            }
                        
                                        
                        
                            body,p,td,th,span,div{  font-family: "AL-Mohanad"; font-size:28px;  }
                            h1,h2,h3,h4,h5{  font-family: "AL-Mohanad";   }
                            .padding-right{
                                padding-right:50px;
                            }
                            .padding-left{
                                padding-left:50px;
                            }
        
                        </style>
                    </head>
                    <body dir="rtl" style="border:1px solid black ; padding :10px;">
                        <div >${body}</div>
                        
                    </body>
                    </html>`;

            let mywindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            mywindow!.document.open();
            let is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            mywindow!.document.write(contents);

            if (is_chrome) {
                setTimeout(function () {
                    mywindow!.document.close();
                    mywindow!.focus();
                    mywindow!.print();
                    // mywindow.close();
                }, 1000);
            } else {
                mywindow!.document.close();
                mywindow!.focus();
                mywindow!.print();
                // mywindow.close();
            }
            // })
        });





    }


}


          //${branchManagerName ? branchManagerName : ''}
          //${qualityName ? qualityName : ''}
          //${returnNumber ? returnNumber : ''}
          //${daysNumber ? daysNumber : ''}